
module.exports = {
  BORDER: "1px solid #dbdbdb",
  BOX_SHADOW: "0 2px 6px 0 rgba(0, 0, 0, 0.12)",
  BORDER_RADIUS: "5px",
  PADDING: "30px",
}
